import { defineMessages } from "react-intl";

export default defineMessages({
    defaultProjectName: {
        id: "onboarding.wizard.defaultProjectName",
        defaultMessage: "My Kanban Project",
        description: "Default name for a new project if none is provided"
    },
    defaultScrumProjectName: {
        id: "onboarding.wizard.defaultScrumProjectName",
        defaultMessage: "My Scrum Project",
        description: "Default name for a new scrum project if none is provided"
    },
    defaultFirstProjectName: {
        id: "onboarding.wizard.defaultFirstProjectName",
        defaultMessage: "My First Project",
        description: "Default name for a new first project if none is provided"
    },
    defaultJsmProjectName: {
        id: "onboarding.wizard.defaultJsmProjectName",
        defaultMessage: "My JSM Project",
        description: "Default name for a new JSM project if none is provided"
    },
    defaultJpdProjectName: {
        id: "onboarding.wizard.defaultJpdProjectName",
        defaultMessage: "My JPD Project",
        description: "Default name for a new JPD project if none is provided"
    },
    defaultCsmProjectName: {
        id: "onboarding.wizard.defaultCustomerServiceProjectName",
        defaultMessage: "My Customer Service Project",
        description:
            "Default name for a new Customer Service project if none is provided"
    }
});
